import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import OverviewFilters from './LocationOverview/OverviewFilters';
// import OverviewTopSection from './LocationOverview/OverviewTopSection';
// import { OverviewMarketSegmentation } from './LocationOverview/OverviewMarketSegmentation';
// import { OverviewVisitorsDemographic } from './LocationOverview/OverviewVisitorsDemographic';
import { OverviewTopPerfomers } from './LocationOverview/OverviewTopPerformers';
import { Box, Typography } from '@mui/material';

import LocationOverviewSidebar from './LocationOverview/LocationOverviewSidebar'
// import OverviewPopup from './LocationOverview/OverviewPopup'
import MenuManagementPopup from './LocationOverview/MenuManagementPopup'
import DataVisualization from './LocationOverview/DataVisualization'
// import MenuItemsAnalysis from './LocationOverview/MenuItemsAnalysis'
// import MenuCannibalization from './LocationOverview/MenuCannibalization'
// import ItemDemographics from './LocationOverview/ItemDemographics'
// import TrafficSources from './LocationOverview/TrafficSources'
// import LoyalCustomers from './LocationOverview/LoyalCustomers'
// import LifecycleStages from './LocationOverview/LifecycleStages'
// import OverviewChartsSection from './LocationOverview/OverviewChartsSection'
import dayjs from 'dayjs';
import mapboxgl from 'mapbox-gl';
import ChatBot from './LocationOverview/ChatBot'

const LocationOverview = () => {
    const map = useRef(null);
    const mapContainer = useRef(null);
    const markersRef = useRef([]);
    const heatmapLayerId = 'heatmap-layer';
    const heatmapSourceId = 'heatmap-data';
    
    const period_comparison_options = [
        { label: 'Month over Month (MoM)', value: 'mom' },
        { label: 'Quarter over Quarter (QoQ)', value: 'qoq' },
        { label: 'Year over Year (YoY)', value: 'yoy' }
    ];
    
    const [analyticsData, setAnalyticsData] = useState(null);
    const [businessData, setBusinessData] = useState([]);
    
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [businessLocations, setBusinessLocations] = useState();

    const [selectedPeriodComparison, setSelectedPeriodComparison] = useState(
        period_comparison_options[0]
    );
    const [dateRange, setDateRange] = useState({
        startDate: dayjs().subtract(30, 'days').toDate(),
        endDate: dayjs().toDate(),
        key: 'selection',
    });
    const [locationOptions, setLocationOptions] = useState([]);
    const [selectedLocations, setSelectedLocations] = useState([]);
    const [businessRevenue, setBusinessRevenue] = useState([]);
    const [activeTab, setActiveTab] = useState('overview');
    const [activeSubTab, setActiveSubTab] = useState(null);
    const [isMenuManagementOpen, setIsMenuManagementOpen] = useState(false);
    const [pendingVisualizationData, setPendingVisualizationData] = useState(null);
    const [sidebarConfig, setSidebarConfig] = useState([]);
    const [executedChartsData, setExecutedChartsData] = useState(new Map());
    const [chartExecutionCache, setChartExecutionCache] = useState(new Map());
    const [loadingCharts, setLoadingCharts] = useState(new Set());

    // Function to collect charts with SQL or filter configuration
    const collectFilterableCharts = (tabId = null) => {
        if (!sidebarConfig || sidebarConfig.length === 0) return [];
        
        const filterableCharts = [];
        
        // Determine which tabs to check
        const tabsToCheck = tabId ? 
            sidebarConfig.filter(tab => tab.id === tabId) : 
            sidebarConfig;
        
        tabsToCheck.forEach(tab => {
            if (tab.children) {
                tab.children.forEach(subtab => {
                    if (subtab.children) {
                        subtab.children.forEach(item => {
                            const { visualizationData } = item;
                            
                            // Check if item has SQL or filter configuration
                            if (visualizationData && 
                                (visualizationData.sql || visualizationData.filterConfig)) {
                                filterableCharts.push({
                                    id: item.id,
                                    tabId: tab.id,
                                    subtabId: subtab.id,
                                    visualizationData: visualizationData,
                                    hasFilters: !!visualizationData.filterConfig
                                });
                            }
                        });
                    }
                });
            }
        });
        
        return filterableCharts;
    };

    // Helper function to generate cache key
    const generateCacheKey = (filters) => {
        return JSON.stringify({
            locations: filters.locations.sort(),
            dateRange: filters.dateRange
        });
    };

    // Helper function to calculate previous period date range
    const calculatePreviousPeriod = (startDate, endDate, periodComparison) => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        const diffDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24));
        
        let prevStart, prevEnd;
        
        switch (periodComparison) {
            case 'mom': // Month over Month
                prevStart = new Date(start);
                prevStart.setMonth(prevStart.getMonth() - 1);
                prevEnd = new Date(end);
                prevEnd.setMonth(prevEnd.getMonth() - 1);
                break;
            case 'qoq': // Quarter over Quarter
                prevStart = new Date(start);
                prevStart.setMonth(prevStart.getMonth() - 3);
                prevEnd = new Date(end);
                prevEnd.setMonth(prevEnd.getMonth() - 3);
                break;
            case 'yoy': // Year over Year
                prevStart = new Date(start);
                prevStart.setFullYear(prevStart.getFullYear() - 1);
                prevEnd = new Date(end);
                prevEnd.setFullYear(prevEnd.getFullYear() - 1);
                break;
            default:
                // Default to previous period of same length
                prevEnd = new Date(start);
                prevEnd.setDate(prevEnd.getDate() - 1);
                prevStart = new Date(prevEnd);
                prevStart.setDate(prevStart.getDate() - diffDays + 1);
        }
        
        return {
            startDate: prevStart.toISOString().split('T')[0],
            endDate: prevEnd.toISOString().split('T')[0]
        };
    };

    // Function to execute charts with current filters
    const executeFilterableCharts = async (tabId = null) => {
        const charts = collectFilterableCharts(tabId);
        
        if (charts.length === 0) {
            console.log('No filterable charts found');
            return;
        }

        console.log(`Found ${charts.length} filterable charts, executing...`);
        
        try {
            // Prepare current filter values
            const currentFilters = {
                locations: selectedLocations,
                dateRange: {
                    startDate: dateRange.startDate.toISOString().split('T')[0], // Convert to YYYY-MM-DD format
                    endDate: dateRange.endDate.toISOString().split('T')[0] // Convert to YYYY-MM-DD format
                }
            };

            // Check cache first
            const cacheKey = generateCacheKey(currentFilters);
            if (chartExecutionCache.has(cacheKey)) {
                console.log('Using cached results for filters:', currentFilters);
                const cachedData = chartExecutionCache.get(cacheKey);
                setExecutedChartsData(new Map(cachedData));
                return;
            }

            // Set loading state for all charts
            const chartIds = charts.map(chart => chart.id);
            setLoadingCharts(new Set(chartIds));

            // Separate box charts from other charts
            const boxCharts = charts.filter(chart => chart.visualizationData?.type === 'box');
            const otherCharts = charts.filter(chart => chart.visualizationData?.type !== 'box');

            // Execute regular charts
            let allResults = [];
            if (otherCharts.length > 0) {
                const response = await axios.post('/workflow/execute-filtered-charts', {
                    charts: otherCharts,
                    filters: currentFilters
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'auth-token': localStorage.getItem('auth-token')
                    }
                });

                if (response.data.success) {
                    allResults = [...response.data.data.results];
                }
            }

            // Execute box charts with current and previous period data
            if (boxCharts.length > 0) {
                // Calculate previous period
                const previousPeriod = calculatePreviousPeriod(
                    currentFilters.dateRange.startDate,
                    currentFilters.dateRange.endDate,
                    selectedPeriodComparison.value
                );

                // Execute current period for box charts
                const currentPeriodResponse = await axios.post('/workflow/execute-filtered-charts', {
                    charts: boxCharts,
                    filters: currentFilters
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'auth-token': localStorage.getItem('auth-token')
                    }
                });

                // Execute previous period for box charts
                const previousFilters = {
                    ...currentFilters,
                    dateRange: previousPeriod
                };

                const previousPeriodResponse = await axios.post('/workflow/execute-filtered-charts', {
                    charts: boxCharts,
                    filters: previousFilters
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'auth-token': localStorage.getItem('auth-token')
                    }
                });

                // Combine current and previous period data for box charts
                if (currentPeriodResponse.data.success && previousPeriodResponse.data.success) {
                    const currentResults = currentPeriodResponse.data.data.results;
                    const previousResults = previousPeriodResponse.data.data.results;

                    // Merge the data for each box chart
                    boxCharts.forEach(chart => {
                        const currentResult = currentResults.find(r => r.chartId === chart.id);
                        const previousResult = previousResults.find(r => r.chartId === chart.id);

                        if (currentResult && currentResult.success && previousResult && previousResult.success) {
                            // Extract values from the results
                            let currentValue = null;
                            let previousValue = null;

                            // Assuming the box chart data is in the first row
                            if (currentResult.data) {
                                currentValue = currentResult.data.currentValue; // First column, first row
                            }
                            if (previousResult.data) {
                                previousValue = previousResult.data.currentValue; // First column, first row
                            }

                            // Calculate change percentage
                            let change = 0;
                            if (currentValue !== null && previousValue !== null && previousValue !== 0) {
                                change = ((currentValue - previousValue) / previousValue) * 100;
                            }
                            // console.log('currentResult: ', currentResult.data)
                            // console.log('previousResult: ',  previousResult.data)

                            // Create combined result
                            const combinedResult = {
                                ...currentResult,
                                data: {
                                    ...currentResult.data,
                                    // Update visualization data with period comparison
                                    ...chart.visualizationData,
                                    currentValue: currentValue,
                                    previousValue: previousValue,
                                    change: change,
                                    data: {
                                        total_current: currentValue,
                                        total_past: previousValue,
                                        total_diff: change
                                    }
                                }
                            };

                            allResults.push(combinedResult);
                        } else if (currentResult && currentResult.success) {
                            // If only current data is available
                            allResults.push(currentResult);
                        }
                    });
                }
            }

            console.log('Chart execution results:', allResults);
            
            // Update executed charts data
            const newExecutedData = new Map(executedChartsData);
            
            allResults.forEach(result => {
                if (result.success) {
                    newExecutedData.set(result.chartId, result.data);
                }
            });
            
            setExecutedChartsData(newExecutedData);
            
            // Cache the results
            setChartExecutionCache(prev => {
                const newCache = new Map(prev);
                newCache.set(cacheKey, newExecutedData);
                return newCache;
            });
            
            // Log any errors
            const errors = allResults.filter(result => !result.success);
            if (errors.length > 0) {
                console.warn('Some charts failed to execute:', errors);
            }
        } catch (error) {
            console.error('Error executing filterable charts:', error);
        } finally {
            // Clear loading state
            setLoadingCharts(new Set());
        }
    };

    // Clear existing markers
    const clearMarkers = () => {
        markersRef.current.forEach(marker => marker.remove());
        markersRef.current = [];
    };

    // Clear existing heatmap
    const clearHeatmap = () => {
        if (!map.current) return;
        
        // Remove all layers that use the heatmap source first
        if (map.current.getLayer('heatmap-points')) {
            map.current.removeLayer('heatmap-points');
        }
        if (map.current.getLayer(heatmapLayerId)) {
            map.current.removeLayer(heatmapLayerId);
        }
        
        // Then remove the source
        if (map.current.getSource(heatmapSourceId)) {
            map.current.removeSource(heatmapSourceId);
        }
    };

    // Create markers for business locations
    const createMarkers = () => {
        if (!map.current || !businessLocations || businessLocations.length === 0) return;
        
        clearMarkers();
        
        businessLocations.forEach((location, index) => {
            if(!selectedLocations.includes(location.name)){
                return
            }
            // Create marker container element
            const markerElement = document.createElement('div');
            markerElement.className = 'business-marker';
            markerElement.innerHTML = `
                <div style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    cursor: pointer;
                ">
                    <div style="
                        font-size: 14px;
                        color: #333;
                        white-space: nowrap;
                        margin-top: 5px;
                    ">
                        ${location.name}
                    </div>
                </div>
            `;
    
            // Create popup content
            const popup = new mapboxgl.Popup({ offset: 25 }).setHTML(`
                <div style="padding: 10px;">
                    <h3 style="margin: 0 0 5px 0; color: #333;">${location.name}</h3>
                    <p style="margin: 0; color: #666; font-size: 12px;">${location.address}</p>
                    <p style="margin: 5px 0 0 0; color: #666; font-size: 12px;">
                        Address: ${location.address}
                    </p>
                </div>
            `);
    
            // Create and add marker (using default marker)
            const marker = new mapboxgl.Marker()
                .setLngLat(location.coordinates)
                .setPopup(popup)
                .addTo(map.current);
    
            // Add custom label element positioned below the marker
            const labelElement = document.createElement('div');
            labelElement.className = 'marker-label';
            labelElement.innerHTML = `
                <div style="
                    position: absolute;
                    top: 35px;
                    left: 50%;
                    transform: translateX(-50%);
                    font-size: 14px;
                    color: #333;
                    white-space: nowrap;
                    pointer-events: none;
                    text-align: center;
                ">
                    ${location.name}
                </div>
            `;
            
            // Add label to marker element
            marker.getElement().appendChild(labelElement);
    
            markersRef.current.push(marker);
        });
    };

    // Create heatmap from analytics data
    const createHeatmap = () => {
        console.log('createHeatmap: ', !map.current, analyticsData, businessLocations)
        if (!map.current || !analyticsData || !businessLocations) return;

        clearHeatmap();

        const heatmapData = analyticsData.current_period?.heatmap;
        if (!heatmapData || heatmapData.length === 0) return;

        // Create GeoJSON features for heatmap
        const features = [];
        
        businessLocations.forEach((location) => {
            console.log('createHeatmap: ', selectedLocations.includes(location.name))
            if (location.heatmap && location.heatmap.length > 0 && selectedLocations.includes(location.name)) {
                location.heatmap.forEach((coord, index) => {
                    if (index < heatmapData.length) {
                        const weight = heatmapData[index];
                        if (weight > 0) {
                            features.push({
                                type: 'Feature',
                                properties: {
                                    weight: weight,
                                    location: location.name,
                                    index: index
                                },
                                geometry: {
                                    type: 'Point',
                                    coordinates: coord
                                }
                            });
                        }
                    }
                });
            }
        });

        if (features.length === 0) return;

        // Add heatmap source
        map.current.addSource(heatmapSourceId, {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: features
            }
        });

        // Add heatmap layer
        map.current.addLayer({
            id: heatmapLayerId,
            type: 'heatmap',
            source: heatmapSourceId,
            maxzoom: 15,
            paint: {
                // Increase the heatmap weight based on frequency and property magnitude
                'heatmap-weight': [
                    'interpolate',
                    ['linear'],
                    ['get', 'weight'],
                    0, 0,
                    200, 0.2,
                    300, 1
                ],
                // Increase the heatmap color weight by zoom level
                // heatmap-intensity is a multiplier on top of heatmap-weight
                'heatmap-intensity': [
                    'interpolate',
                    ['linear'],
                    ['zoom'],
                    0, 1,
                    15, 3
                ],
                // Color ramp for heatmap
                'heatmap-color': [
                    'interpolate',
                    ['linear'],
                    ['heatmap-density'],
                    0, 'rgba(33,102,172,0)',
                    0.2, 'rgb(103,169,207)',
                    0.4, 'rgb(209,229,240)',
                    0.6, 'rgb(253,219,199)',
                    0.8, 'rgb(239,138,98)',
                    1, 'rgb(178,24,43)'
                ],
                // Adjust the heatmap radius by zoom level
                'heatmap-radius': [
                    'interpolate',
                    ['linear'],
                    ['zoom'],
                    0, 2,
                    15, 20
                ],
                // Transition from heatmap to circle layer by zoom level
                'heatmap-opacity': [
                    'interpolate',
                    ['linear'],
                    ['zoom'],
                    7, 1,
                    15, 0
                ]
            }
        });

        // Add circle layer for individual points at high zoom levels
        map.current.addLayer({
            id: 'heatmap-points',
            type: 'circle',
            source: heatmapSourceId,
            minzoom: 14,
            paint: {
                'circle-radius': [
                    'interpolate',
                    ['linear'],
                    ['get', 'weight'],
                    200, 5,
                    300, 15
                ],
                'circle-color': [
                    'interpolate',
                    ['linear'],
                    ['get', 'weight'],
                    200, 'rgb(103,169,207)',
                    250, 'rgb(253,219,199)',
                    300, 'rgb(178,24,43)'
                ],
                'circle-stroke-color': 'white',
                'circle-stroke-width': 1,
                'circle-opacity': [
                    'interpolate',
                    ['linear'],
                    ['zoom'],
                    14, 0,
                    15, 1
                ]
            }
        });

        // Add click event for heatmap points
        map.current.on('click', 'heatmap-points', (e) => {
            const coordinates = e.features[0].geometry.coordinates.slice();
            const properties = e.features[0].properties;
            
            // Ensure that if the map is zoomed out such that multiple
            // copies of the feature are visible, the popup appears
            // over the copy being pointed to
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }

            new mapboxgl.Popup()
                .setLngLat(coordinates)
                .setHTML(`
                    <div style="padding: 8px;">
                        <h4 style="margin: 0 0 5px 0;">Heatmap Point</h4>
                        <p style="margin: 0; font-size: 12px;">Location: ${properties.location}</p>
                        <p style="margin: 0; font-size: 12px;">Weight: ${properties.weight}</p>
                        <p style="margin: 0; font-size: 12px;">Index: ${properties.index}</p>
                    </div>
                `)
                .addTo(map.current);
        });

        // Change cursor on hover
        map.current.on('mouseenter', 'heatmap-points', () => {
            map.current.getCanvas().style.cursor = 'pointer';
        });

        map.current.on('mouseleave', 'heatmap-points', () => {
            map.current.getCanvas().style.cursor = '';
        });
    };

    // Update map when data changes
    const updateMap = (source) => {
        if (!map.current) return;

        // Wait for map to be fully loaded
        // if (!map.current.isStyleLoaded()) {
        //     map.current.on('styledata', updateMap);
        //     return;
        // }
        console.log('updateMap: ', source)
        createMarkers();
        createHeatmap();

        // Fit map to show all markers if we have business locations
        if (businessLocations && businessLocations.length > 0) {
            const bounds = new mapboxgl.LngLatBounds();
            businessLocations.forEach(location => {
                bounds.extend(location.coordinates);
            });
            
            // Add some padding around the bounds
            map.current.fitBounds(bounds, {
                padding: 50,
                maxZoom: 12
            });
        }
    }; 
    const arraysEqual = (arr1, arr2) => {
        if (arr1.length !== arr2.length) return false;
        return arr1.every((val, index) => val === arr2[index]);
    }

    // Fetch analytics data from API
    const fetchAnalyticsData = async ({startDate, endDate, selectedPeriodComparison, selectedLocations}) => {
        setLoading(true);
        setError(null);
        const urlParams = new URLSearchParams(window.location.search);

        try {
            // const requestBody = {
            //     start_date: startDate.toISOString().split('T')[0],
            //     end_date: endDate.toISOString().split('T')[0],
            //     comparison_period: selectedPeriodComparison,
            //     location: selectedLocations,
            //     demoToken: urlParams.get('demo-token')

            // };
            const response = await axios.post('/gettheurl/business-locations', {}, {
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': localStorage.getItem('auth-token')
                }
            });
            const data = response.data.business;
            // setAnalyticsData(data);
            setBusinessData(data)

            // console.log('fetchAnalyticsData: ', !arraysEqual(data.period.locations, selectedLocations), selectedLocations)
            // if(!arraysEqual(data.period.locations, selectedLocations)){
                
            //     setSelectedLocations(data.period.locations);
            // }

            // if(data.current_period.revenueByLocation){
            //     var busLocations = businessLocations;
            //     if(data.period.business_locations){
            //         busLocations = data.period.business_locations;
            //     }
            //     // console.log('busLocations: ', busLocations)
            //     const business_revenue = busLocations.map((bus) => {
            //         const revenue = data.current_period.revenueByLocation[bus['name']]
            //         return {...bus, revenue}
            //     })
            //     // console.log('business_revenue: ', business_revenue)
            //     setBusinessRevenue(business_revenue)
            // }else{
            //     setBusinessRevenue([])
            // }

            
            // if(data.period.business_locations){
            //     setBusinessLocations(data.period.business_locations);
            //     setLocationOptions(data.period.locations);
            // }
            
            // console.log('Analytics data received:', data);
        } catch (err) {
            console.error('Error fetching analytics data:', err);
            setError(err.response?.data?.error || 'Failed to fetch analytics data');
        } finally {
            setLoading(false);
        }
    };

    // Handle filter changes from OverviewFilters component
    const onFilterConditionChange = (selectedLocations, selectedPeriodComparison, startDate, endDate) => {
        if (startDate && endDate) {
            fetchAnalyticsData({
                selectedLocations,
                selectedPeriodComparison: selectedPeriodComparison.value,
                startDate,
                endDate
            });
        
            setDateRange({    
                startDate: startDate,
                endDate: endDate,
                key: 'selection',
            });
            setSelectedLocations(selectedLocations);
            setSelectedPeriodComparison(selectedPeriodComparison);
        }
    };

    

    // Helper function to format numbers with commas
    const numberWithCommas = (x) => {
        if (!x) return "No Data";
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    // Initialize map
    useEffect(() => {
        if (map.current) return; 
        
        mapboxgl.accessToken = 'pk.eyJ1Ijoic25pa2FlaW4iLCJhIjoiY2s1eWNpcWxrMDJvbzNtcDdyb3puNTVrMCJ9.t-VFWsbpRo--tRSLgLa9ng';
        
        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/light-v10',
            center: [-95, 38.2],
            zoom: 3.5
        });
        
        map.current.scrollZoom.disable();
        map.current.addControl(new mapboxgl.NavigationControl());

        // Update map when style is loaded
        map.current.on('load', () => {
            console.log('Map loaded, updating markers and heatmap');
            updateMap('map loaded');
        });
    }, []);

    // Update map when analytics data or business locations change
    useEffect(() => {
        console.log('Analytics data changed:', analyticsData);
        console.log('Business locations:', businessLocations);
        console.log('Selected locations:', selectedLocations);
        console.log('Map loaded:', map.current, map.current?.isStyleLoaded());

        if (map.current && activeTab === 'customer-locations') {
            if (map.current.isStyleLoaded()) {
                updateMap('analyticsData');
            } else {
                // Wait for style to load, then update
                map.current.once('styledata', () => {
                    console.log('Style loaded, now updating map');
                    updateMap('analyticsData');
                });
            }
        }
    }, [analyticsData, businessLocations, selectedLocations, activeTab]);

    // Effect to execute filterable charts when sidebar config, active tab, or filters change
    useEffect(() => {
        if (sidebarConfig.length > 0) {
            // Clear cache when period comparison changes since it affects box chart calculations
            setChartExecutionCache(new Map());
            // Execute charts for the current active tab
            executeFilterableCharts(activeTab);
        }
    }, [sidebarConfig, activeTab, selectedLocations, dateRange, selectedPeriodComparison]);

    // useEffect(() => {
    //     if (map.current && map.current.isStyleLoaded()) {
    //         updateMap('selectedLocations');
    //     }
    // }, [selectedLocations])

    // Transform analytics data for child components
    const getTransformedData = () => {
        if (!analyticsData) return null;
        const current = analyticsData.current_period;
        const comparison = analyticsData.comparison_period;
        return {
            current: current,
            comparison: comparison,
            changes: analyticsData.changes || {},
            period: analyticsData.period,
            comparisonInfo: analyticsData.comparison_info
        };
    };

    // Initialize default sidebar configuration with proper structure
    const initializeDefaultSidebarConfig = () => {
        return [
            { 
                id: 'overview', 
                label: 'Overview', 
                type: 'tab',
                component: 'OverviewTopSection',
                order: 0
            },
            { 
                id: 'customer-locations', 
                label: 'Customer Locations', 
                type: 'tab',
                isSection: true,
                order: 1,
                children: [
                    {
                        id: 'customer-locations-default',
                        label: 'Default',
                        type: 'subtab',
                        isCustom: true,
                        order: 0,
                        children: []
                    }
                ]
            }
        ];
    };

    // Check authentication on mount and load saved layout
    useEffect(() => {
        const token = localStorage.getItem("auth-token");
        if (!token) {
            console.log('No auth token found');
        }
        
        // Load saved sidebar configuration
        loadSavedSidebarConfig();
    }, []);

    // Handle save graph events from ChatBot
    const handleSaveGraphToMain = (visualizationData) => {
        console.log('Save graph event received:', visualizationData);
        setPendingVisualizationData(visualizationData);
        setIsMenuManagementOpen(true);
    };

    // Initial data fetch
    // useEffect(() => {
    //     fetchAnalyticsData({
    //         selectedLocations,
    //         selectedPeriodComparison: selectedPeriodComparison.value,
    //         startDate: dateRange.startDate,
    //         endDate: dateRange.endDate
    //     });
    // }, [dateRange]);

    // Placeholder functions for components that need them
    const login = () => {
        console.log('Login clicked');
    };

    const register = () => {
        console.log('Register clicked');
    };

    const focusLocation = (location) => {
        const coordinates = location['coordinates']
        // console.log('location: ', location)
        map.current.flyTo({
            center: coordinates,
            zoom: 10
            });
    };

    const transformedData = getTransformedData();

    const boxClickFunction = ({key, value}) => {
        
    }

    const handleTabChange = (tabId, subTabId = null) => {
        setActiveTab(tabId);
        setActiveSubTab(subTabId);
        
        // Show/hide map based on tab and trigger resize
        if (map.current) {
            const mapContainer = map.current.getContainer();
            if (tabId === 'customer-locations') {
                mapContainer.style.display = 'block';
                // Trigger map resize to ensure it fills the container properly
                setTimeout(() => {
                    map.current.resize();
                }, 100);
            } else {
                mapContainer.style.display = 'none';
            }
        }

        // Scroll to subtab if specified
        if (subTabId) {
            setTimeout(() => {
                const subtabElement = document.getElementById(`subtab-${subTabId}`);
                if (subtabElement) {
                    subtabElement.scrollIntoView({ 
                        behavior: 'smooth', 
                        block: 'start',
                        inline: 'nearest'
                    });
                }
            }, 100);
        }
    };


    // Function to organize orphaned graphs under default subtabs
    const organizeOrphanedGraphs = (config) => {
        const config_main = config.map(tab => {
            // Handle customer-locations tab specifically
            if (tab.id === 'customer-locations') {
                // Ensure customer-locations has proper structure
                if (!tab.children) tab.children = [];
                
                let defaultSubtab = tab.children.find(subtab => subtab.id === 'customer-locations-default');
                
                if (!defaultSubtab) {
                    defaultSubtab = {
                        id: 'customer-locations-default',
                        label: 'Default',
                        type: 'subtab',
                        isCustom: true,
                        children: [],
                        order: 0
                    };
                    tab.children.unshift(defaultSubtab); // Add at the beginning
                }

                // Ensure default subtab has OverviewTopPerformers
                if (!defaultSubtab.children) defaultSubtab.children = [];
                
                const hasOverviewTopPerformers = defaultSubtab.children.some(child => 
                    child.component === 'OverviewTopPerformers'
                );

                if (!hasOverviewTopPerformers) {
                    const overviewTopPerformersItem = {
                        id: 'customer-locations-overview-performers',
                        label: 'Customer Performance Overview',
                        type: 'component',
                        component: 'OverviewTopPerformers',
                        isDefault: true,
                        order: 0
                    };
                    defaultSubtab.children.unshift(overviewTopPerformersItem);
                }

                // Find and organize orphaned graphs
                const orphanedGraphs = tab.children.filter(child => child.type === 'graph');
                const subtabs = tab.children.filter(child => child.type !== 'graph');

                if (orphanedGraphs.length > 0) {
                    // Move orphaned graphs to default subtab
                    orphanedGraphs.forEach((graph, index) => {
                        graph.parentSubTab = defaultSubtab.id;
                        graph.order = defaultSubtab.children.length + index;
                        defaultSubtab.children.push(graph);
                    });
                }

                // Update orders for all subtabs
                subtabs.forEach((subtab, index) => {
                    subtab.order = index;
                });

                return {
                    ...tab,
                    children: subtabs,
                    isSection: true
                };
            }

            // Handle other tabs - original logic
            if (!tab.children) return tab;

            // Find direct graph children (orphaned graphs)
            const orphanedGraphs = tab.children.filter(child => child.type === 'graph');
            const subtabs = tab.children.filter(child => child.type !== 'graph');

            if (orphanedGraphs.length === 0) return tab;

            // Create or find default subtab
            let defaultSubtab = subtabs.find(subtab => subtab.id.endsWith('-default'));
            
            if (!defaultSubtab) {
                defaultSubtab = {
                    id: `${tab.id}-default`,
                    label: 'Default',
                    type: 'subtab',
                    isCustom: true,
                    children: [],
                    order: subtabs.length
                };
                subtabs.push(defaultSubtab);
            }

            // Move orphaned graphs to default subtab
            if (!defaultSubtab.children) defaultSubtab.children = [];
            orphanedGraphs.forEach((graph, index) => {
                graph.parentSubTab = defaultSubtab.id;
                graph.order = (defaultSubtab.children.length || 0) + index;
                defaultSubtab.children.push(graph);
            });

            // Update orders
            subtabs.forEach((subtab, index) => {
                subtab.order = index;
            });

            return {
                ...tab,
                children: subtabs,
                isSection: subtabs.length > 0
            };
        });
        console.log('config_main: ', config_main)
        return config_main
    };

    // Load saved sidebar configuration from API
    const loadSavedSidebarConfig = async () => {
        try {
            const response = await axios.get('/workflow/get-layout', {
                headers: {
                    'auth-token': localStorage.getItem('auth-token')
                }
            });

            if (response.data.success) {
                const { sidebarConfig: savedConfig, hasCustomLayout } = response.data.data;
                if (hasCustomLayout && savedConfig.length > 0) {
                    // Organize any orphaned graphs before setting the config
                    const organizedConfig = organizeOrphanedGraphs(savedConfig);
                    setSidebarConfig(organizedConfig);
                    console.log('Loaded and organized saved sidebar configuration:', organizedConfig);
                } else {
                    // Use default configuration with proper structure
                    const defaultConfig = initializeDefaultSidebarConfig();
                    setSidebarConfig(defaultConfig);
                }
            }
        } catch (error) {
            console.error('Error loading sidebar configuration:', error);
            
            // Redirect to login on authentication errors
            if (error.response?.status === 400 || error.response?.status === 401) {
                const currentUrl = encodeURIComponent(window.location.pathname + window.location.search);
                window.location.href = `/login?redirect=${currentUrl}`;
                return;
            }
            
            // Use default configuration on other errors
            const defaultConfig = initializeDefaultSidebarConfig();
            setSidebarConfig(defaultConfig);
        }
    };

    // Handle menu management popup save
    const handleMenuManagementSave = (newSidebarConfig) => {
        // Organize orphaned graphs when receiving new config
        const organizedConfig = organizeOrphanedGraphs(newSidebarConfig);
        setSidebarConfig(organizedConfig);
        console.log('Sidebar configuration updated and organized:', organizedConfig);
    };

    // Handle menu management popup close
    const handleMenuManagementClose = () => {
        setIsMenuManagementOpen(false);
        setPendingVisualizationData(null);
    };

    // Get saved charts for a specific subtab
    const getSavedChartsForSubTab = (subTabId) => {
        const charts = [];
        
        // Find the subtab and get its child graphs
        sidebarConfig.forEach(tab => {
            if (tab.children) {
                tab.children.forEach(subTab => {
                    if (subTab.id === subTabId && subTab.children) {
                        subTab.children.forEach(item => {
                            if (item.type === 'graph' && item.visualizationData) {
                                charts.push(item);
                            }
                        });
                    }
                });
            }
        });
        
        return charts;
    };

    // Get all subtabs for a tab to render the full tab content
    const getSubTabsForTab = (tabId) => {
        const currentTab = sidebarConfig.find(tab => tab.id === tabId);
        if (currentTab && currentTab.children) {
            return currentTab.children.filter(child => child.type !== 'graph');
        }
        return [];
    };

    const renderSavedCharts = (charts) => {
        if (charts.length === 0) return null;
        
        return (
            <Box sx={{ mt: 3 }}>
                {/* Box components - 3 per row */}
                {charts.filter(chart => chart.visualizationData?.type === 'box').length > 0 && (
                    <Box sx={{ 
                        display: 'grid', 
                        gap: 3,
                        gridTemplateColumns: {
                            xs: '1fr',
                            sm: 'repeat(2, 1fr)',
                            md: 'repeat(3, 1fr)',
                            lg: 'repeat(4, 1fr)'
                        },
                        mb: 3
                    }}>
                        {charts.filter(chart => chart.visualizationData?.type === 'box').map((chart, index) => {
                            // Use executed data if available, otherwise use original data
                            const executedData = executedChartsData.get(chart.id);
                            const isLoading = loadingCharts.has(chart.id);
                            const visualizationData = executedData || chart.visualizationData;
                            
                            return (
                                <Box key={chart.id || index}>
                                    <DataVisualization 
                                        visualizationData={visualizationData}
                                        onSaveToMain={null}
                                        boxClickFunction={boxClickFunction}
                                        isLoading={isLoading}
                                    />
                                </Box>
                            );
                        })}
                    </Box>
                )}
                
                {/* Tables and charts - full width */}
                {charts.filter(chart => chart.visualizationData?.type && chart.visualizationData.type !== 'box').map((chart, index) => {
                    // Use executed data if available, otherwise use original data
                    const executedData = executedChartsData.get(chart.id);
                    const isLoading = loadingCharts.has(chart.id);
                    const visualizationData = executedData || chart.visualizationData;
                    
                    return (
                        <Box key={chart.id || index} sx={{ mb: 3, width: '100%' }}>
                            <DataVisualization 
                                visualizationData={visualizationData}
                                onSaveToMain={null}
                                boxClickFunction={boxClickFunction}
                                isLoading={isLoading}
                            />
                        </Box>
                    );
                })}
            </Box>
        );
    };

    const renderSubTabContent = (subTab) => {
        const charts = getSavedChartsForSubTab(subTab.id);
        
        return (
            <Box 
                id={`subtab-${subTab.id}`}
                sx={{ mb: 4, scrollMarginTop: '20px' }}
            >
                <Typography variant="h4" sx={{ mb: 3, fontWeight: 600 }}>
                    {subTab.label}
                </Typography>
                
                {/* Render default components if they exist */}
                {subTab.children && subTab.children.filter(child => child.type === 'component').map(component => (
                    // <Box key={component.id} sx={{ mb: 3 }}>
                        component.component === 'OverviewTopPerformers' && (
                            <OverviewTopPerfomers
                                analyticsData={transformedData}
                                loading={loading}
                                businessRevenue={businessRevenue}
                                focusLocation={focusLocation}
                            />
                        )
                    // </Box>
                ))}
                
                {renderSavedCharts(charts)}
                
                {charts.length === 0 && !subTab.children?.some(child => child.type === 'component') && subTab.id !== 'customer-locations-default' && (
                    <Typography variant="body2" color="text.secondary">
                        No charts in this section yet.
                    </Typography>
                )}
            </Box>
        );
    };

    const renderActiveComponent = () => {
        // If a specific subtab is selected, show the full tab with all subtabs but scroll to the selected one
        if (activeSubTab) {
            const subTabs = getSubTabsForTab(activeTab);            
            return (
                <Box sx={{ p: 3 }}>
                    {subTabs.map(subTab => renderSubTabContent(subTab))}
                </Box>
            );
        }
        
        // Render standard components based on tab
        switch (activeTab) {
            case 'customer-locations':
                // For customer locations, render subtabs with default visualizations
                const performersSubTabs = getSubTabsForTab(activeTab);
                if (performersSubTabs.length > 0) {
                    return (
                        <Box sx={{ p: 3 }}>
                            {performersSubTabs.map(subTab => (
                                <Box 
                                    key={subTab.id}
                                    id={`subtab-${subTab.id}`}
                                    sx={{ mb: 4, scrollMarginTop: '20px' }}
                                >
                                    <Typography variant="h4" sx={{ mb: 3, fontWeight: 600 }}>
                                        {subTab.label}
                                    </Typography>
                                    {/* Render saved charts for this subtab */}
                                    {renderSavedCharts(getSavedChartsForSubTab(subTab.id))}
                                    {/* For default subtab, show the map and OverviewTopPerformers */}
                                    {subTab.id === 'customer-locations-default' && (
                                            <OverviewTopPerfomers
                                                analyticsData={transformedData}
                                                loading={loading}
                                                businessRevenue={businessRevenue}
                                                focusLocation={focusLocation}
                                            />
                                    )}
                                    {getSavedChartsForSubTab(subTab.id).length === 0 && subTab.id !== 'customer-locations-default' && (
                                        <Typography variant="body2" color="text.secondary">
                                            No charts in this section yet.
                                        </Typography>
                                    )}
                                </Box>
                            ))}
                        </Box>
                    );
                }
                break;
            default:
                // For custom tabs, render all subtabs
                const subTabs = getSubTabsForTab(activeTab);
                if (subTabs.length > 0) {
                    return (
                        <Box sx={{ p: 3 }}>
                            {subTabs.map(subTab => renderSubTabContent(subTab))}
                        </Box>
                    );
                }
                break;
        }
        
        // Fallback for tabs without content
        return (
            <Box sx={{ p: 3 }}>
                <Typography variant="h4" sx={{ mb: 3 }}>
                    No content available for this section yet.
                </Typography>
            </Box>
        );
    };

    return (
        <div>
            {/* <OverviewPopup/> */}
            {error && (
                <div className="error-message" style={{ 
                    color: 'red', 
                    padding: '10px', 
                    margin: '10px 0',
                    border: '1px solid red',
                    borderRadius: '4px',
                    backgroundColor: '#ffe6e6'
                }}>
                    Error: {error}
                </div>
            )}
            
            {loading && (
                <div className="loading-message" style={{
                    padding: '20px',
                    textAlign: 'center',
                    fontSize: '16px'
                }}>
                    Loading analytics data...
                </div>
            )}
                
            {/* Fixed Left Navigation Sidebar */}
            <LocationOverviewSidebar 
                activeTab={activeTab}
                activeSubTab={activeSubTab}
                onTabChange={handleTabChange}
                sidebarConfig={sidebarConfig}
            />
            
            {/* Main Content Area with Conditional Left Margin */}
            <Box sx={{ marginLeft:  '180px', display: 'flex', flexDirection: 'column' }}>
                {/* Filters Section */}
                <Box sx={{ padding: '20px', paddingBottom: '10px' }}>
                    <OverviewFilters 
                        dateRange={dateRange}
                        selectedPeriodComparison={selectedPeriodComparison}
                        period_comparison_options={period_comparison_options}
                        locationOptions={businessData}
                        selectedLocations={selectedLocations}
                        onFilterConditionChange={onFilterConditionChange}
                        loading={loading}
                    />
                </Box>
                
                {/* Content Area */}
                <Box sx={{ padding: '20px', paddingTop: '0' }}>
                    {/* Keep original sidebar for additional functionality */}
                    

                    
                    {/* Render Active Component Based on Selected Tab */}
                    {renderActiveComponent()}
                                        {/* Persistent Map Container */}
                                        <div 
                        ref={mapContainer} 
                        id="mapbox" 
                        style={{ 
                            // width: 'calc(100vw - 180px - 40px)', 
                            // height: '400px', 
                            // marginBottom: '20px', 
                            // position: 'relative',
                            display: activeTab === 'customer-locations' ? 'block' : 'none'
                        }} 
                    />
                </Box>
            </Box>
            <ChatBot onSaveToMain={handleSaveGraphToMain} />
            
            {/* Menu Management Popup */}
            <MenuManagementPopup
                open={isMenuManagementOpen}
                onClose={handleMenuManagementClose}
                onSave={handleMenuManagementSave}
                currentSidebarConfig={sidebarConfig}
                visualizationData={pendingVisualizationData}
                organizeOrphanedGraphs={organizeOrphanedGraphs}
            />
        </div>
    );
};

export default LocationOverview;